module.exports = __webpack_public_path__ + "img/student-grid.svg";